import { useRequest } from "ahooks";
import { gdSlsReportError } from "./gdSlsRum";

/**
 * 重写useRequest的onError方法，用于上报错误
 * @type {import("ahooks").useRequest}
 */
export default function useReq(fn, options = {}) {
  // useRequest 在服务端使用cacheKey 会导致内存泄漏
  // https://github.com/alibaba/hooks/issues/1914
  if (typeof window === "undefined") {
    delete options?.cacheKey;
  }
  return useRequest(fn, {
    ...options,
    onError: (error) => {
      gdSlsReportError(error);
      console.error("useReq Error:", error);
      options.onError?.(error);
    },
  });
}
